import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { getNameSelector } from '../../../selectors/dialog'

export function useDialogName(dialogId: string) {
  return useSelector<RootState, string | undefined>(getNameSelector(dialogId))
}
